import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { Provider } from 'react-redux';
import store from './app/store';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { register } from './utils/serviceWorkerRegistration';


console.log('🚀 App starting at:', new Date().toISOString());
console.log('📱 User Agent:', navigator.userAgent);
console.log('🌐 Location:', window.location.href);

// Global Error Handler for mobile debugging
const showError = (error, type = 'Error') => {
  const overlay = document.getElementById('error-overlay');
  const messageBox = document.getElementById('error-message');
  const deviceInfo = document.getElementById('device-info');

  if (overlay && messageBox) {
    overlay.style.display = 'block';
    messageBox.textContent = `[${type}]\n${error.message || error}\n\nStack:\n${error.stack || 'No stack trace available'}`;

    if (deviceInfo) {
      deviceInfo.textContent = `User Agent: ${navigator.userAgent}\nURL: ${window.location.href}\nTime: ${new Date().toISOString()}`;
      deviceInfo.style.whiteSpace = 'pre-wrap';
    }
  }
};

window.onerror = (message, source, lineno, colno, error) => {
  showError(error || message, 'Runtime Error');
  return false;
};

window.onunhandledrejection = (event) => {
  showError(event.reason, 'Unhandled Promise Rejection');
};

try {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
} catch (error) {
  showError(error, 'Mount Error');
}

// Register service worker for PWA functionality
// Register service worker in both dev and production for mobile testing
register({
  onSuccess: () => {
    console.log('✅ Service Worker: App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('🔄 Service Worker: New version available');
    // Don't auto-update here - let the update notification banner handle it.
    // The banner shows "Update Now" / "Later" buttons.
    // When user clicks "Update Now", it sends SKIP_WAITING → controllerchange → reload.
    // Auto-updating here causes a reload loop on mobile.
  },
  onError: (error) => {
    console.error('❌ Service Worker registration failed:', error);
  }
});